<div class="mat-bg-surface flex flex--column">
  <mat-toolbar>
    <h1>Client Accounts</h1>

    <span class="spacer"></span>
    <div class="cell-actions">
      @if (canEdit) {
        <button matMiniFab matTooltip="Add Client Account" (click)="edit()">
          <mat-icon>add</mat-icon>
        </button>
      }

      <button matIconButton (click)="reload()">
        <mat-icon [class.rotating]="pending()">refresh</mat-icon>
      </button>
    </div>
  </mat-toolbar>

  <div class="grid">
    <section class="c-12">
      <div class="cell-actions">
        <mat-form-field class="c-12">
          <mat-label>Search</mat-label>
          <input matInput [(ngModel)]="filter" />
          <mat-icon matSuffix>search</mat-icon>
        </mat-form-field>
        <mat-form-field class="c-12">
          <mat-label> Commissionable </mat-label>
          <mat-select multiple [(ngModel)]="filterCommissionable" placeholder="Any">
            <mat-option [value]="true">Yes</mat-option>
            <mat-option [value]="false">No</mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <table
        mat-table
        matSort
        [dataSource]="source()"
        [trackBy]="trackBy"
        matSortActive="ClientCode"
        matSortDirection="asc"
      >
        <ng-container matColumnDef="Links">
          <th mat-header-cell *matHeaderCellDef></th>
          <td mat-cell *matCellDef="let item">
            <div class="cell-actions">
              @if (item.XeroId) {
                <a
                  matIconButton
                  target="_blank"
                  href="https://go.xero.com/Contacts/View.aspx?contactID={{ item.XeroId }}"
                  matTooltip="Xero ID: {{ item.XeroId }}"
                >
                  <img alt="Xero logo" src="../../assets/img/xero-logo.png" />
                </a>
              }
              @if (item.InsightlyId) {
                <a
                  matIconButton
                  target="_blank"
                  href="https://googleapps.insight.ly/details/Organisations/Details/{{ item.InsightlyId }}"
                  matTooltip="Insighly ID: {{ item.InsightlyId }}"
                >
                  <img alt="Insightly logo" src="../../assets/img/insightly-logo.png" />
                </a>
              }
            </div>
          </td>
        </ng-container>

        <ng-container matColumnDef="ClientCode">
          <th mat-header-cell mat-sort-header *matHeaderCellDef>Code</th>
          <td mat-cell *matCellDef="let item">{{ item.ClientCode }}</td>
        </ng-container>

        <ng-container matColumnDef="Commissionable">
          <th mat-header-cell *matHeaderCellDef>Commissionable</th>
          <td mat-cell *matCellDef="let item">{{ item.Commissionable ? 'Yes' : 'No' }}</td>
        </ng-container>

        <ng-container matColumnDef="ClientName">
          <th mat-header-cell mat-sort-header *matHeaderCellDef>Client</th>
          <td mat-cell *matCellDef="let item">{{ item.ClientName }}</td>
        </ng-container>

        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef></th>
          <td mat-cell *matCellDef="let item">
            <div class="cell-actions">
              <button matIconButton matTooltip="Products" [routerLink]="['/app/products', item.ClientCode]">
                <mat-icon>shopping_bag</mat-icon>
              </button>
              <button matIconButton matTooltip="Agreements" [routerLink]="['/app/agreements', item.ClientCode]">
                <mat-icon>assignment</mat-icon>
              </button>

              @if (canEdit) {
                <button matMiniFab matTooltip="Edit client" (click)="edit(item)" [disabled]="pending()">
                  <mat-icon>edit</mat-icon>
                </button>
              }
              <button matMiniFab matTooltip="View client" [routerLink]="['view', item.ClientCode]">
                <mat-icon>remove_red_eye</mat-icon>
              </button>
            </div>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="columnsToShow()"></tr>
        <tr mat-row *matRowDef="let row; columns: columnsToShow()"></tr>
      </table>

      <mat-paginator [pageSize]="10" [showFirstLastButtons]="true" />
    </section>
  </div>
</div>
